export const cursorTimeDebounceDelay = 1000;
export const cursorTimeThrottleDelay = 500;
export const currentBucketRefetchInterval = 60000; // 1000 * 60
